<div class="error-container p-4">
    <div>
        <img src="assets/img/dbc-onboard-v2/error-parsing.svg" class="error-parse-img" />
    </div>
    <p class="error-detail">Details not detected</p>
    <p class="error-description">
        Ensure the image details are clear to save the contact from the
        card.
    </p>

    <button
        type="button" class="retake-btn mt-3 cursor-pointer"
        (click)="handleRetakeImage()"
    >
        Retake Image
    </button>
    <button
        type="button" class="enter-manual-btn mt-3 cursor-pointer"
        (click)="handleEnterManualDetails()"
    >
        Enter Contact Details
    </button>
</div>
